import { v4 as uuid } from 'uuid';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showPersonNameDialog = ({ requestId = uuid(), ...options } = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_PERSON_NAME_DIALOG,
  payload: { ...options, requestId },
});

export const hidePersonNameDialog = (requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_PERSON_NAME_DIALOG,
  payload: { requestId },
});

export const personNameDialogSaved = (personName, requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.PERSON_NAME_DIALOG_SAVED,
  payload: { personName, requestId },
});
